export const environment = {
  production: true,
  workerEnabled: true,
  channelsVersion: '2025.3.3.943',
  apiUrl: 'assets/data/appConfig-production.json'
};
